import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
// import {debugLogger} from "../../utils/LogDebug";

const FormAddress = ({ trajet, type, reservationData, handleChange }) => {
    const isPickup = type === "pu"; // Vérifie si c'est un Départ
    const sectionTitle = isPickup ? "Departure Address" : "Arrival Address";
    const sectionHeader = isPickup ? reservationData[`lieu_pu_${trajet}`] : reservationData[`lieu_drop_${trajet}`];
    // Récupération des hôtels directement depuis `reservationData`


    const hotelsData = [
        { name: "Budjet Sarcelles", address: "Rosier", zip: "95200", city: "Sarcelles" },
        { name: "Hotel Disneyland Paris", address: "Rue de la Marnière", zip: "77700", city: "Chessy" },
        { name: "Disney's Hotel New York", address: "Avenue René Goscinny", zip: "77700", city: "Chessy" },
        { name: "Disney's Hotel Cheyenne", address: "Rue du Bœuf Agile", zip: "77700", city: "Chessy" },
        { name: "Hotel Disney's Newport Bay Club", address: "Avenue Robert Schuman", zip: "77700", city: "Chessy" },
        { name: "Sequoia Lodge Disney", address: "Avenue Robert Schuman", zip: "77700", city: "Chessy" },
        { name: "Disney's Hotel Santa Fe", address: "Avenue Robert Schuman", zip: "77700", city: "Chessy" },
        { name: "Hotel Adagio Marne la Vallée", address: "42 Cours du Danube", zip: "77700", city: "Serris" },
        { name: "Hipark Adagio-Val d'Europe", address: "18 Cours de l'Elbe", zip: "77700", city: "Serris" },
        { name: "Explorers Hotel at Disneyland", address: "50 Av de la Fosse des Pressoirs", zip: "77700", city: "Magny le Hongre" },
        { name: "B&B Hotel at Disneyland", address: "60 Av de la Fosse des Pressoirs", zip: "77700", city: "Magny le Hongre" },
        { name: "Grand Magic Hotel at Disneyland", address: "20 Av de la Fosse des Pressoirs", zip: "77700", city: "Magny le Hongre" },
        { name: "Dream Castle Hotel at Disneyland", address: "40 Av de la Fosse des Pressoirs", zip: "77700", city: "Magny le Hongre" },
        { name: "Campanile Hotel at Disneyland", address: "10 Av de la Fosse des Pressoirs", zip: "77700", city: "Magny le Hongre" },
        { name: "Park&Suites Prestige Val d'Europe", address: "21 Avenue des Frênes", zip: "77144", city: "Montervraine" },
        { name: "Résidence Du Parc", address: "2 Rue Édouard Buffard", zip: "77144", city: "Montervraine" },
        { name: "Relais SPA Chessy", address: "1 Rue des Grands Prés", zip: "77700", city: "Chessy" },
        { name: "Hôtel l'Élysée Val d'Europe", address: "7 Cours du Danube", zip: "77700", city: "Serris" },
        { name: "hotel ibis Marne La Vallée Val d'Europe", address: "2 Place Jean Monnet", zip: "77144", city: "Montervraine" },
        { name: "Ibis Budget Marne La Vallée Val d'Europe", address: "6 Rue de la Gare", zip: "77144", city: "Montervraine" },
        { name: "Residhome Prestige Val d'Europe", address: "2 Place Jean Monnet", zip: "77144", city: "Montervraine" },
        { name: "Radisson Blu Hotel Paris, Marne-la-Vallée", address: "40 Allee de La Mare Houleuse", zip: "77700", city: "Magny le Hongre" },
        { name: "Sejours et Affaires Residence Hoteliere Rive Gauche", address: "20 Cours du Danube", zip: "77700", city: "Serris" },
        { name: "Hotel Campanile Bussy Saint Georges", address: "8 Avenue Marie Curie", zip: "77600", city: "Bussy Saint Georges" },
        { name: "B&B Hôtel Bussy Saint Georges", address: "6 Avenue Marie Curie", zip: "77600", city: "Bussy Saint Georges" },
        { name: "Première Classe Bussy Saint Georges", address: "8 Avenue Marie Curie", zip: "77600", city: "Bussy Saint Georges" },
        { name: "Center Parcs Villages Nature Paris", address: "Route De Villeneuve", zip: "77700", city: "Bailly-Romainvilliers" },
        { name: "Stay City Apart Hotel Near Disney", address: "All. de l'Orme Rond", zip: "77700", city: "Bailly-Romainvilliers" },
        { name: "Hotel Marriott's Village d'ille de France near Disney", address: "All. de l'Orme Rond", zip: "77700", city: "Bailly-Romainvilliers" },
        { name: "Tulip Inn Hotel Bussy Saint Georges", address: "44 Boulevard Antoine Giroust", zip: "77600", city: "Bussy Saint Georges" },
        { name: "GOLF HOTEL", address: "15 Avenue du Golf", zip: "77600", city: "Bussy Saint Georges" },
        { name: "Villa Bellagio Bussy Saint Georges", address: "39 Boulevard de Lagny", zip: "77600", city: "Bussy Saint Georges" }
    ];


    // Extraire les codes postaux et supprimer les doublons
    const lesCPArrive = [...new Set(reservationData.cp_arrive.map(cpVille => cpVille.split(" ")[0]))] || [];
    const lesCPDepart = [...new Set(reservationData.cp_depart.map(cpVille => cpVille.split(" ")[0]))] || [];

    // Filtre les Hotels ayant ces code postaux
    const hotelFiltered = hotelsData.filter(hotel =>
        lesCPArrive.includes(hotel.zip) || lesCPDepart.includes(hotel.zip)
    ).sort((a,b) => a.name.localeCompare(b.name));

    
    const handleHotelChange = (event) => {
        const selectedHotelName = event.target.value;
        const selectedHotel = hotelsData.find(h => h.name === selectedHotelName);
    
        if (selectedHotel) {
            handleChange({ target: { id: `address_${type}_${trajet}`, value: selectedHotel.address } });
            handleChange({ target: { id: `zip_${type}_${trajet}`, value: selectedHotel.zip } });
            handleChange({ target: { id: `hotel_${type}_${trajet}`, value: selectedHotel.name } });
        }
    
        handleChange(event);
    };
    
    return (
        <div className="form-section address-section m-0 p-2">
            <div className="section-header">{sectionHeader}</div>
            <h3><FontAwesomeIcon icon={faHome} /> &nbsp;{sectionTitle}</h3>
            {hotelFiltered.length > 0 && (
                <label htmlFor={`list_hotel_${type}_${trajet}`}>
                    Choose a Hotel:
                    <select
                        id={`list_hotel_${type}_${trajet}`}
                        value={reservationData[`hotel_${type}_${trajet}`] || ""}
                        onChange={handleHotelChange}
                    >
                        <option value="">Select a hotel</option>
                        {hotelFiltered.map((hotel, index) => (
                            <option key={index} value={hotel.name}>
                                {hotel.name} - {hotel.city}
                            </option>
                        ))}
                    </select>
                </label>
            )}

            <label>
                Hotel Name:
                <input
                    type="text"
                    id={`hotel_${type}_${trajet}`}
                    value={reservationData[`hotel_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    placeholder="Enter hotel name (if applicable)"
                />
            </label>

            <label>
                Address:
                <input
                    type="text"
                    id={`address_${type}_${trajet}`}
                    value={reservationData[`address_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    placeholder="Enter address"
                    required
                />
            </label>

            <label>
                Zip Code:
                <input
                    type="text"
                    id={`zip_${type}_${trajet}`}
                    value={reservationData[`zip_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    placeholder="Enter zip code"
                    required
                />
            </label>


        </div>
    );
};

export default FormAddress;
